import {useMutation, useQueryClient} from "react-query";
import Alert from "react-s-alert";
import {HubAndSpokeService} from "../../../services/HubAndSpokeService";

export const useDeleteSftpConfig = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (sftpConfigId: string) => {
      return await HubAndSpokeService.deleteSftpConfig(sftpConfigId);
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries("GET_SFTP_CONFIGS");
        Alert.success("Configuration successfully deleted!");
      },
      onError: (error: any) => {
        Alert.error(error?.data?.detail ?? "Failed to delete configuration.");
      },
    },
  );
};
